//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class ExtractReportModel extends ModelBase {
      static readonly $typeName = 'ExtractReportModel';
      public extractControllerUrl: string;
      public name: string;
      public permission: string;
      public type: string;
      public reportPath: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/report/models/ExtractReportModel.ts